export default "__VITE_ASSET__Dx6ZQVmJ__"